import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

const PrivacyPolicyPage = () => {
  return (
    <div className="container mx-auto py-8 px-4 max-w-4xl">
      <Card>
        <CardHeader>
          <CardTitle className="text-3xl">Privacy Policy</CardTitle>
          <p className="text-muted-foreground">Last updated: {new Date().toLocaleDateString()}</p>
        </CardHeader>
        <CardContent className="prose prose-sm max-w-none dark:prose-invert">
          <h2 className="text-2xl font-semibold mt-6 mb-3">1. Information We Collect</h2>
          <p>We collect information you provide directly, including:</p>
          <ul>
            <li>Account information (email, name, profile details)</li>
            <li>Professional information (career stats, achievements)</li>
            <li>Usage data (how you interact with the platform)</li>
            <li>Social media connections (when you authorize integration)</li>
          </ul>
          
          <h2 className="text-2xl font-semibold mt-6 mb-3">2. How We Use Your Information</h2>
          <ul>
            <li>To provide and maintain the TheSlice service</li>
            <li>To personalize your experience</li>
            <li>To analyze and improve our platform</li>
            <li>To communicate with you about updates and features</li>
          </ul>
          
          <h2 className="text-2xl font-semibold mt-6 mb-3">3. Data Sharing</h2>
          <p>We do not sell your personal information. We may share data with:</p>
          <ul>
            <li>Service providers who assist in platform operations</li>
            <li>Other users (only information you choose to make public)</li>
            <li>Law enforcement when required by law</li>
          </ul>
          
          <h2 className="text-2xl font-semibold mt-6 mb-3">4. Data Security</h2>
          <p>We implement industry-standard security measures including encryption, access controls, and regular security audits.</p>
          
          <h2 className="text-2xl font-semibold mt-6 mb-3">5. Your Rights</h2>
          <p>You have the right to:</p>
          <ul>
            <li>Access your personal data</li>
            <li>Correct inaccurate data</li>
            <li>Request deletion of your data</li>
            <li>Export your data</li>
            <li>Opt-out of marketing communications</li>
          </ul>
          
          <h2 className="text-2xl font-semibold mt-6 mb-3">6. Cookies and Tracking</h2>
          <p>We use cookies and similar technologies for authentication, preferences, and analytics. You can control cookie settings through your browser.</p>
          
          <h2 className="text-2xl font-semibold mt-6 mb-3">7. Children's Privacy</h2>
          <p>TheSlice is not intended for users under 13. We do not knowingly collect information from children.</p>
          
          <h2 className="text-2xl font-semibold mt-6 mb-3">8. International Data Transfers</h2>
          <p>Your data may be processed in countries other than your own. We ensure appropriate safeguards are in place.</p>
          
          <h2 className="text-2xl font-semibold mt-6 mb-3">9. Changes to Privacy Policy</h2>
          <p>We will notify you of significant changes to this policy via email or platform notification.</p>
          
          <h2 className="text-2xl font-semibold mt-6 mb-3">10. Contact Us</h2>
          <p>For privacy concerns, email privacy@theslice.com</p>
        </CardContent>
      </Card>
    </div>
  );
};

export default PrivacyPolicyPage;
